export interface Tool {
  id: string;
  name: string;
  type: string;
  slogan: string;
  highlights: string[];
  icon: string;
  url?: string;
}

export const tools: Tool[] = [
  {
    id: 'live-assistant',
    name: '直播助手',
    type: '赋能直播运营',
    slogan: 'AI让直播更简单、效率',
    highlights: [
      '抖音直播实时控场与助理',
      '直播间水军控评',
      '直播间自动智能回复',
      '粉丝评论智能分析',
    ],
    icon: 'ri-live-line',
    url: 'http://129.204.149.109:5010',
  },
  {
    id: 'smart-farming',
    name: '智慧养殖管理平台',
    type: '信息化系统',
    slogan: '智慧养殖数字化解决方案',
    highlights: [
      '生产管理',
      '日常管理',
      '基础配置',
      '全面养殖记录体系的数据运营',
    ],
    icon: 'ri-plant-line',
    url: 'http://spm-admin.luyuras.com',
  },
  {
    id: 'data-cockpit',
    name: '数据驾驶舱',
    type: '数据统计跟踪',
    slogan: '智能驱动,AI赋能,科技引领农业未来',
    highlights: [
      'AI应用统计',
      '用户活跃统计',
      '热启动效果价值闭环',
      '多产品数据整合',
    ],
    icon: 'ri-bar-chart-box-line',
    url: 'https://stats.luyuaqua.com',
  },
];
